import { TranslocoPipe, provideTranslocoScope } from '@jsverse/transloco';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

// Cliente rifiutato dalla proposta (blocco attivo o codici non validi), col messaggio del backend
@Component({
  providers: [provideTranslocoScope('orders')],
  selector: 'ord-customer-blocked-dialog',
  imports: [TranslocoPipe, MatButtonModule, MatDialogModule],
  template: `
    <mat-dialog-content class="blocked-content">
      <div class="blocked-icon">
        <i class="fa-regular fa-circle-exclamation"></i>
      </div>
      <span class="title-medium-emphasized">{{ 'orders.ui.clienteNonSelezionabile' | transloco }}</span>
      <span class="body-small">{{ data.message }}</span>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button matButton="filled" type="button" class="blocked-confirm" mat-dialog-close>{{ 'orders.ui.hoCapito' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styles: `
    .blocked-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--mat-sys-spacing-8);
      text-align: center;
    }

    .blocked-icon {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 56px;
      border-radius: 100%;
      color: var(--mat-sys-on-surface-variant);
      background-color: var(--mat-sys-primary-container);
    }

    .blocked-confirm {
      width: 100%;
    }
  `,
})
export class CustomerBlockedDialog {
  readonly data = inject<{ message: string }>(MAT_DIALOG_DATA);
}
